import { useCallback, useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { isValidRedirectPath } from "../../utils";
import LoadingIndicator from "../LoadingIndicator";
import { RoutePaths } from "~/enums";



export function NotAuthenticatedInfo() {
  const router = useHistory();
  const location = useLocation();

  // redirect path from search params - eg: areaxt.com?redirectUrl=...
  const searchRedirectPath = useMemo(() => {
    if (location.search === "") {
      return;
    }
    const parsedSearchParams = new URLSearchParams(location.search);

    return parsedSearchParams.get("redirectUrl");
  }, [location]);
  const searchRedirectPathIsValid = isValidRedirectPath(searchRedirectPath);

  // redirect path from current path - eg: areaxt.com/content
  const currentRedirectPath = location.pathname;
  const currentRedirectPathIsValid = isValidRedirectPath(currentRedirectPath);

  const redirectPathToUse = useMemo(() => {
    if (searchRedirectPathIsValid) {
      return searchRedirectPath || "";
    }
    if (currentRedirectPathIsValid) {
      return currentRedirectPath || "";
    }

    return "";
  }, [
    currentRedirectPathIsValid,
    currentRedirectPath,
    searchRedirectPath,
    searchRedirectPathIsValid,
  ]);

  const redirectPathForParam = useMemo(
    () =>
      encodeURIComponent(redirectPathToUse.replace(window.location.origin, "")),
    [redirectPathToUse],
  );

  const handleGoToLoginPage = useCallback(() => {
    const newRoute = redirectPathForParam
      ? `${RoutePaths.LOGIN}?redirect=${redirectPathForParam.replace("?", "")}`
      : RoutePaths.LOGIN;
    router.push(newRoute);
  }, [redirectPathForParam, router]);

  useEffect(() => {
    const _t = 250;
    setTimeout(handleGoToLoginPage, _t);
  }, [handleGoToLoginPage]);

  return <LoadingIndicator />;
}
